import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { teacherMenuItems } from "../components/TeacherMenuItems";
import AccessTokenModal from "../components/AccessTokenModal";

import TeacherFeedback from "../components/TeacherFeedback";

import "../styles/TeacherDashboard.css";
import TeacherStudentHeader from "../components/TeacherStudentHeader";

const TeacherFeedbackPage = () => {
  const [activeItem, setActiveItem] = useState("feedback"); // Set default to "feedback"
  const [isVideoMode, setIsVideoMode] = useState(true);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setActiveItem("feedback"); // Ensure activeItem is set to "feedback" on page load
  }, []);

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery("");
  };

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: false };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };
  useEffect(() => {
    setActiveItem("feedback"); // Set active item to "feedback" when the feedback page loads
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    setActiveItem(""); // No active menu item during search
  };

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        teacherMenuItems={teacherMenuItems}
        activeItem={activeItem} // Pass activeItem
        setActiveItem={handleActiveItemChange} // Pass setActiveItem
      />
      <main className="main-content">
        <div className="content">
          <TeacherFeedback />
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default TeacherFeedbackPage;
